import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/sections/PageHero";
import CTABlock from "../components/sections/CTABlock";
import { services } from "../data/services";

export default function ExpertisePage() {
  return (
    <>
      <PageHero
        eyebrow="Practice Areas"
        title="Expertise"
        subtitle="Legal support across litigation, dispute resolution, real estate, RERA, corporate advisory, contract drafting, risk management and regulatory matters."
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Expertise" }]}
      />

      {/* INTRO */}
      <section className="bg-ivory pt-4 md:pt-8 pb-12 md:pb-20" data-testid="expertise-intro">
        <div className="container-px max-w-[1400px] mx-auto grid md:grid-cols-12 gap-10">
          <div className="md:col-span-7 md:col-start-3">
            <div className="editorial-rule mx-auto mb-8 hidden" />
            <p className="body-lg text-charcoal/80 mb-5">
              Lex Polaris, Advocates &amp; Solicitors provides research-driven and strategy-focused legal
              support across litigation, dispute resolution, real estate, RERA, corporate advisory, contract
              drafting, due diligence and regulatory matters.
            </p>
            <p className="body-lg text-charcoal/70">
              The firm advises individuals, businesses, start-ups, real estate stakeholders and corporate
              clients on legally sound, commercially practical and outcome-oriented solutions.
            </p>
          </div>
        </div>
      </section>

      {/* GRID */}
      <section className="bg-white border-y border-soft-grey" data-testid="expertise-grid">
        <div className="container-px max-w-[1400px] mx-auto py-16 md:py-24">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-soft-grey border border-soft-grey">
            {services.map((s, idx) => (
              <Link
                key={s.slug}
                to={`/expertise/${s.slug}`}
                data-testid={`expertise-card-${s.slug}`}
                className="group bg-white p-9 md:p-11 hover:bg-ivory transition-colors duration-300 flex flex-col"
              >
                <div className="flex items-start justify-between mb-7">
                  <span className="font-serif text-gold text-base">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <ArrowUpRight
                    size={18}
                    className="text-navy/40 group-hover:text-gold group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all duration-300"
                  />
                </div>
                <h3 className="font-serif text-2xl md:text-[26px] text-navy leading-tight mb-3">
                  {s.title}
                </h3>
                <p className="text-sm text-charcoal/70 leading-relaxed mb-8 flex-1">{s.short}</p>
                <span className="text-[11px] tracking-[0.22em] uppercase text-navy border-b border-navy/30 pb-1 self-start group-hover:text-gold group-hover:border-gold transition-colors">
                  Read More
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CTABlock />
    </>
  );
}
